// src/components/SuperAdminLogin.jsx

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, db, provider, signInWithPopup } from '../../firebase';
import { doc, getDoc } from 'firebase/firestore';

export default function SuperAdminLogin() {
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleLogin = async () => {
        setLoading(true);
        setError('');

        try {
            const result = await signInWithPopup(auth, provider);
            const user = result.user;
            const superAdminRef = doc(db, 'super_admins', user.email);
            const snap = await getDoc(superAdminRef);

            // 1) Check that the doc exists
            if (!snap.exists()) {
                setError('Not authorized as super admin.');
                return;
            }

            // 2) Check that status === "active"
            const { status } = snap.data();
            if (status !== 'active') {
                setError('Your super-admin access is not active.');
                return;
            }

            // 3) All good—redirect to dashboard
            navigate('/dashboard');
            console.log('Super-admin logged in');
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
            <div className="bg-white p-8 rounded-lg shadow-md text-center">
                <h2 className="text-2xl mb-4 font-semibold">Super Admin Login</h2>
                <button
                    onClick={handleLogin}
                    disabled={loading}
                    className={`w-64 py-3 rounded-md text-lg font-medium transition-colors duration-300 ${loading
                            ? 'bg-gray-400 cursor-not-allowed'
                            : 'bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700'
                        } text-white shadow-lg`}
                >
                    {loading ? 'Signing in...' : 'Sign in with Google'}
                </button>
                {error && <p className="mt-4 text-red-500">{error}</p>}
            </div>
        </div>
    );
}
